import React from "react";
import App from "./App";
import "./i18n";
import "./index.css";
import "./datadog-rum";
import { InstUISettingsProvider } from "@instructure/ui";
import { createRoot } from "react-dom/client";

import { NotificationProvider } from "./components/CustomHooks/NotificationProvider";
import { themeWithOverrides } from "./themeOverride";

import { BrowserRouter } from "react-router";
import { StatusProvider } from "./components/CustomHooks/StatusProvider";
import ScrollToTop from "./components/Helpers/ScrollToTop";

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <InstUISettingsProvider theme={themeWithOverrides}>
    <BrowserRouter>
      <ScrollToTop>
        <NotificationProvider>
          <StatusProvider>
            <App />
          </StatusProvider>
        </NotificationProvider>
      </ScrollToTop>
    </BrowserRouter>
  </InstUISettingsProvider>
);
